import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var CleanInput = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.581L8.581 1m0 7.581L1 1",
    stroke: "#CCC",
    strokeWidth: 1.6,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }));
});
CleanInput.displayName = 'CleanInput';

export { CleanInput, CleanInput as default };
